export default __webpack_public_path__ + "static/media/BabyPac.d1097aa7.gif";